var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsIconInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9947 17.4775L21.9992 17.9998L21.5938 17.4775V17.1338L21.9947 17.4775Z",
    fill: "#CE2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.0002L18.0344 16.1042C17.811 15.9981 17.5695 15.9431 17.3253 15.9429H0V0.512695H20.0871V12.9726C20.0868 13.2353 20.1379 13.4952 20.2371 13.7352L22 18.0002Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V15.4302H17.3253C17.5696 15.4298 17.8112 15.4848 18.0344 15.5915L21.7354 17.3618L22 17.485C21.9996 17.4822 21.9996 17.4793 22 17.4764L20.2417 13.2213C20.1423 12.9813 20.0912 12.7214 20.0916 12.4587V0H0Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4068 3.35352H2.4469C2.08251 3.35352 1.78711 3.67122 1.78711 4.06312C1.78711 4.45502 2.08251 4.77272 2.4469 4.77272H17.4068C17.7712 4.77272 18.0666 4.45502 18.0666 4.06312C18.0666 3.67122 17.7712 3.35352 17.4068 3.35352Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4658 6.66602H2.47034C2.10595 6.66602 1.81055 6.98372 1.81055 7.37562C1.81055 7.76752 2.10595 8.08522 2.47034 8.08522H11.4658C11.8302 8.08522 12.1256 7.76752 12.1256 7.37562C12.1256 6.98372 11.8302 6.66602 11.4658 6.66602Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1061 9.97852H2.47034C2.10595 9.97852 1.81055 10.2962 1.81055 10.6881C1.81055 11.08 2.10595 11.3977 2.47034 11.3977H14.1061C14.4705 11.3977 14.7659 11.08 14.7659 10.6881C14.7659 10.2962 14.4705 9.97852 14.1061 9.97852Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.28522,
    y1: -3.01088,
    x2: 11.7772,
    y2: 15.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIconInactive);
export default __webpack_public_path__ + "static/media/sms-icon-inactive.cf2fe7c25f3a15ebaf2d52b20a927256.svg";
export { ForwardRef as ReactComponent };